(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-page-right-thumbs"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.reacherProductTabScrollFixInstalled) return;
  window.reacherProductTabScrollFixInstalled = true;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('product-tab .toggleLink[data-collapsible]');
    if (!trigger || !trigger.closest('[data-product-tab-scroll-fix]')) return;

    const tabs = trigger.closest('product-tab');
    if (typeof tabs.tabToggle !== 'function') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const panel = trigger.parentElement.nextElementSibling;
    const animatedPanel = panel && typeof window.jQuery === 'function' ? window.jQuery(panel) : null;
    if (animatedPanel) animatedPanel.stop(true, true);
    tabs.tabToggle({
      currentTarget: trigger,
      target: event.target,
      preventDefault: () => event.preventDefault(),
      stopPropagation: () => event.stopPropagation()
    });
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
